/**
 * SharePoint configuration row helpers (API/SQL may use mixed property casing).
 * Kept separate from sharePointService so UI can import without named exports from the service module.
 */

export function normalizeSharePointConfigRow(row) {
  if (!row || typeof row !== 'object') return row;
  const tenant_url =
    row.tenant_url ?? row.Tenant_url ?? row.TENANT_URL ?? row.TenantUrl ?? '';
  const client_id =
    row.client_id ?? row.Client_id ?? row.CLIENT_ID ?? row.ClientId ?? '';
  const tenant_id =
    row.tenant_id ?? row.Tenant_id ?? row.TENANT_ID ?? row.TenantId ?? '';
  const id = row.id ?? row.Id ?? row.sharepoint_config_id ?? row.Sharepoint_config_id;
  const client_secret = row.client_secret ?? row.Client_secret ?? '';
  const is_subsite = row.is_subsite ?? row.IsSubsite;
  const parent_config_id = row.parent_config_id ?? row.Parent_config_id;
  const site_path = row.site_path ?? row.Site_path ?? '';
  return {
    ...row,
    id,
    tenant_url,
    client_id,
    tenant_id,
    client_secret,
    is_subsite,
    parent_config_id,
    site_path
  };
}

/** Prefer root (non-subsite) row for credential forms. */
export function pickPrimarySharePointConfig(configs) {
  const list = Array.isArray(configs) ? configs.map(normalizeSharePointConfigRow) : [];
  if (list.length === 0) return null;
  const parent = list.find((r) => r.is_subsite !== true && r.is_subsite !== 1);
  return parent || list[0];
}
